import { createRoute } from "@tanstack/react-router";
import { z } from "zod";

import { brandRoute } from "../../platform/routes";
import { ActorsScreen } from "./ActorsScreen";

// `?view=`: the page's tab, My Actors (the default, as live), Global Actors or My Generations.
// Anything malformed is dropped.
const actorsSearch = z.object({
  view: z.enum(["mine", "global", "generations"]).optional().catch(undefined),
});

/** Live's AI Actors page (`/app/actors-ai`): a brand's actors, so it hangs under the brand. */
export const actorsRoute = createRoute({
  getParentRoute: () => brandRoute,
  path: "actors",
  validateSearch: (search) => actorsSearch.parse(search),
  component: ActorsScreen,
});
